import type { RouteResources } from '@atlassian/react-resource-router/src/common/types.tsx';
import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';
import type {
	JiraLegacyRoute,
	JiraLegacyRouteOptions,
} from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { createRouteEntry } from './createRouteEntry.tsx';

/**
 * Create a route entry for legacy pages.
 */
export const createLegacyEntry: (
	baseRoute: InvariantJiraRoute,
	opts: () => JiraLegacyRouteOptions<RouteResources>,
) => JiraLegacyRoute<RouteResources> = createRouteEntry<
	InvariantJiraRoute,
	JiraLegacyRouteOptions<RouteResources>,
	JiraLegacyRoute<RouteResources>
>;
